export interface RealPowerSubscriber {
  agent_name?: string;
  agent_id?: string;
  subscription_id: string;
  customer_id: string;
  customer_name: string;
  zone_code: string;
  fdt_code: string;
  fat_code: string;
  username: string;
  status: string;
  expires_at: string;
  optical_rx_power: string;
  optical_tx_power?: string;
  power_state: string;
  ont_serial: string;
  ont_vendor: string;
  has_active_session: boolean;
  updated_at?: string;
}

export const REAL_POWER_SUBSCRIBERS: RealPowerSubscriber[] = [];
export const realPowerMap = new Map<string, RealPowerSubscriber>();

export function populateMap(subs: RealPowerSubscriber[]) {
  subs.forEach(s => {
    if (s.subscription_id) realPowerMap.set(String(s.subscription_id), s);
    if (s.username) realPowerMap.set(String(s.username).toLowerCase(), s);
    if (s.customer_name) realPowerMap.set(String(s.customer_name).trim(), s);
  });
}

let loadPromise: Promise<void> | null = null;

export function ensureSubscribersLoaded(): Promise<void> {
  if (realPowerMap.size > 0) return Promise.resolve();
  if (!loadPromise) {
    if (typeof window !== 'undefined') {
      const targetUrl = `${window.location.origin}/real_power_subscribers.json`;
      loadPromise = fetch(targetUrl)
        .then(r => r.json())
        .then((data: any) => {
          const subs = data?.subscribers || [];
          if (subs.length > 0) {
            populateMap(subs);
            REAL_POWER_SUBSCRIBERS.length = 0;
            REAL_POWER_SUBSCRIBERS.push(...subs);
            console.log(`[RealPowerData] Loaded ${subs.length} real subscribers into memory.`);
          }
        })
        .catch((err) => {
          console.warn('[RealPowerData] Background load error:', err);
        });
    } else {
      loadPromise = Promise.resolve();
    }
  }
  return loadPromise;
}

// Automatically trigger load on module import
ensureSubscribersLoaded();

export function getRealPowerRecord(idOrUserOrName: string): RealPowerSubscriber | undefined {
  if (!idOrUserOrName) return undefined;
  const str = String(idOrUserOrName).trim();
  const rec = realPowerMap.get(str) || realPowerMap.get(str.toLowerCase());
  if (rec && rec.optical_rx_power) {
    const p = parseFloat(rec.optical_rx_power);
    if (!isNaN(p)) rec.optical_rx_power = `${p.toFixed(2)} dBm`;
  }
  return rec;
}

export function updateSubscriberNetworkElement(subIdOrUsername: string, fdtCode: string, fatCode: string, ontSerial?: string, ontVendor?: string) {
  if (!subIdOrUsername) return;
  const str = String(subIdOrUsername).trim();
  const rec = realPowerMap.get(str) || realPowerMap.get(str.toLowerCase());
  if (rec) {
    if (fdtCode) rec.fdt_code = fdtCode;
    if (fatCode) rec.fat_code = fatCode;
    if (ontSerial) rec.ont_serial = ontSerial;
    if (ontVendor) rec.ont_vendor = ontVendor;
    rec.updated_at = new Date().toISOString();
  }
}

